<template>
  <div>
    <v-dialog
      class="paper-dialog"
      title="Create a New Paper"
      :visible.sync="dialogVisible"
      width="65vw"
      @open="onOpen"
      @close="onClosed"
    >
    
      <el-form
        class="padding-lr"
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="190px"
      >
        <el-form-item label=" " prop="">
        <p class="right-find" >
            <i class="el-icon-warning-outline"></i
            >请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站：
            <a href="https://www.rightfind.com" target="_blank"
              >https://www.rightfind.com</a
            >
          </p>
        </el-form-item>
        <el-form-item label="Content Category" prop="categoryId">
          <div class="cate-select-add">
            <el-select
              placeholder="Please select content category"
              v-model="form.categoryId"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :value="item.PaperCategoryID"
                :key="index"
                :label="item.CategoryName"
              >
                <div class="select-option-item" :title="item.CategoryName">
                  {{ item.CategoryName }}
                </div>
              </el-option>
            </el-select>
            <el-button icon="el-icon-plus" @click="showCateDialog" />
          </div>
        </el-form-item>
        <el-form-item label="Short Title" prop="shortTitle">
          <el-input
            placeholder="Please input short title"
            v-model="form.shortTitle"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="Search Term" prop="searchTerm">
          <el-input
            placeholder="Please input search term"
            v-model="form.searchTerm"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="Security Level" prop="levelID">
          <el-select
            v-model="form.levelID"
            placeholder="Please select security level"
          >
            <el-option
              v-for="(item, index) in securityLevels"
              :label="item.Name"
              :value="item.Id"
              :key="index"
            />
          </el-select>
          <p class="security-level">
            <i class="el-icon-warning-outline"></i>本平台禁止传输Orange/Red
            CCI文件。
          </p>
        </el-form-item>
        <el-form-item label="Upload PDF">
          <FileUpload
            ref="fileUpload"
            action="/content/uploadFile"
            accept=".PDF,.pdf"
            message="Only PDF file can be uploaded"
            @success="handleSuccess"
            @fail="handleFail"
          />
          <div v-if="uploadFile" class="upload-file">
            <!-- <a :href="`/online-preview/${uploadFile.code||'pdf'}`" target="_blank" :title="fileName"></a> -->
            <a :href="uploadFile.url" target="_blank" :title="fileName">
              <i class="el-icon-document"></i>
              {{ fileName }}
            </a>
            <span @click="uploadFile = null">
              <i class="el-icon-close"></i>
            </span>
          </div>
        </el-form-item>
        <el-form-item
          label="Allow Full Article Request"
          prop="fullPaperRequest"
        >
          <el-radio-group v-model="form.fullPaperRequest">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="0">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Content" prop="paperContent" class="editor">
          <TinymceEditor
            v-if="visible"
            ref="vTinymce"
            v-model="form.paperContent"
            :height="300"
            @input="paperContentValidator"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="push-footer">
        <el-button type="primary" @click="onPreview" :loading="previewing">
          {{ previewLabel }}
        </el-button>
        <el-button type="primary" @click="onSubmit"> Submit </el-button>
        <el-button plain @click="dialogVisible = false"> Cancel </el-button>
      </div>
    </v-dialog>
    <NewCategoryDialog
      :visible.sync="addCategoryDialogVisible"
      @success="onNewCateSuccess"
      @closed="onNewCateClosed"
    />
    <QRCodeDialog :visible.sync="qrcodeDialogVisible" :data.sync="previewUrl" />
  </div>
</template>
<script>
import TinymceEditor from "../../components/tinymce-editor";
import QRCodeDialog from "./qrcode-dialog";
import NewCategoryDialog from "./new-category-dialog";
import FileUpload from "../../components/file-upload";
import { trimValidate } from "../../utils/validator";
export default {
  name: "new-paper-dialog",
  components: { TinymceEditor, NewCategoryDialog, QRCodeDialog, FileUpload },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      seList: [],
      categoryList: [],
      securityLevels: [
        {
          Name: "Green",
          Id: 1,
        },
        {
          Name: "Yellow",
          Id: 2,
        },
      ],
      form: {
        seId: null,
        categoryId: "",
        shortTitle: "",
        searchTerm: "",
        levelID: "",
        fullPaperRequest: 1,
        paperContent: "",
      },
      formRules: {
        categoryId: [
          {
            required: true,
            message: "Please select content category",
            trigger: "change",
          },
        ],
        shortTitle: [
          {
            required: true,
            validator: trimValidate("Please input short title"),
            trigger: "blur",
          },
        ],
        searchTerm: [
          {
            required: true,
            validator: trimValidate("Please input search term"),
            trigger: "blur",
          },
        ],
        levelID: [
          {
            required: true,
            message: "Please select security level",
            trigger: "change",
          },
        ],
        fileName: [
          { required: true, message: "It must be filled", trigger: "blur" },
        ],
        uploadName: [
          { required: true, message: "It must be filled", trigger: "blur" },
        ],
        fullPaperRequest: [
          {
            required: true,
            message: "Please check the full paper request radio button",
            trigger: "blur",
          },
        ],
        paperContent: [
          {
            required: true,
            message: "Please input content",
            trigger: "change",
          },
        ],
      },
      addCategoryDialogVisible: false,
      hidePaperDialog: false,
      uploadFile: null,
      previewing: false,
      qrcodeDialogVisible: false,
      previewUrl: "",
    };
  },
  computed: {
    fileName() {
      return this.uploadFile ? this.uploadFile.file.name : null;
    },
    uploadName() {
      return this.uploadFile ? this.uploadFile.fileNameSave : null;
    },
    previewLabel() {
      return this.previewing ? "Previewing" : "Preview";
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {
    onClosed() {
      if (!this.hidePaperDialog) {
        this.uploadFile = null;
        this.$refs.fileUpload.reset();
        this.$refs.form.resetFields();
        this.$emit("update:visible", false);
      }
    },
    onOpen() {
      this.getSEList();
      this.getCategoryList();
      this.getSecurityLevel();
    },
    onPreview() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.previewing = true;
          this.axios
            .post("/content/preview", {
              ...this.form,
              shortTitle: this.form.shortTitle.trim(),
              searchTerm: this.form.searchTerm.trim(),
              fileName: this.fileName,
              uploadName: this.uploadName,
            })
            .then(({ code, data }) => {
              if (code == 200) {
                this.previewUrl = data.url;
                this.qrcodeDialogVisible = true;
              } else {
                this.$message.error("Get preview qrcode failed");
              }
              this.previewing = false;
            })
            .catch(() => {
              this.previewing = false;
            });
        } else {
          return false;
        }
      });
    },
    getSEList() {
      this.axios.get("/content/seList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.seList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    getCategoryList() {
      this.axios.get("/content/categoryList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.categoryList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    getSecurityLevel() {
      this.axios.get("/content/securityLevel").then(({ code, data, msg }) => {
        if (code === 200) {
          this.securityLevels = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    paperContentValidator() {
      const vTinymce = this.$refs.vTinymce;
      if (vTinymce) {
        const editor = vTinymce.getEditor();
        if (editor) {
          const text = editor.getContent({ format: "text" }).trim();
          const html = editor.getContent({ format: "html" });
          if (
            html.indexOf("video") === -1 &&
            html.indexOf("img") === -1 &&
            html.indexOf("table") === -1
          ) {
            if (text.length > 0) {
              this.$refs.form.clearValidate("paperContent");
            }
            if (text.length === 0 && this.visible) {
              this.$set(this.form, "paperContent", "");
              this.$refs.form.validateField("paperContent");
            }
          } else {
            this.$refs.form.clearValidate("paperContent");
          }
        }
      }
    },
    onSubmit() {
      this.paperContentValidator();
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.axios
            .post("/content/addPaper", {
              ...this.form,
              shortTitle: this.form.shortTitle.trim(),
              searchTerm: this.form.searchTerm.trim(),
              fileName: this.fileName,
              uploadName: this.uploadName,
            })
            .then(({ code, msg }) => {
              if (code == 200) {
                this.$message.success("Create content successfully");
                this.$emit("success");
                this.$emit("update:visible", false);
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    handleSuccess(file) {
      this.uploadFile = file;
      this.$message.success("Upload file successfully");
    },
    handleFail() {
      this.$message.error("Upload file failed");
    },
    showCateDialog() {
      this.hidePaperDialog = true;
      this.dialogVisible = false;
      this.addCategoryDialogVisible = true;
    },
    onNewCateSuccess(categoryId) {
      this.getCategoryList();
      this.form.categoryId = categoryId;
    },
    onNewCateClosed() {
      this.hidePaperDialog = false;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-dialog {
  ::v-deep .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 67vh;
  }
}

::v-deep {
  .select-option-item {
    max-width: 38vw;
  }
}
.push-footer {
  text-align: center;
}
.el-select + .el-button {
  margin-left: 10px;
}
.padding-lr {
  padding: 0 15px;
}
.el-uploader {
  margin-right: 15px;
}
.upload-file {
  display: inline-flex;
  align-items: center;
  a {
    margin-right: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    overflow: hidden;
  }
  span {
    cursor: pointer;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: $theme-color;
    &:hover {
      color: #606266;
    }
  }
}
.el-form-item {
  margin-bottom: 15px !important;
  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }
  &.editor {
    margin-bottom: 0 !important;
    height: 315px;
  }
  .cate-select-add {
    width: 90%;
    display: flex;
    .el-select {
      flex: 1;
    }
  }

  .security-level,
  .right-find {
    margin-top: 5px;
    width: 90%;
    color: #e6a23c;
    line-height: 20px;
    font-size: 12px;
    word-break: break-word;

    &,
    i {
      font-weight: bold;
    }

    i {
      margin-right: 3px;
    }

    a {
      text-decoration: underline;
    }
  }
}
.security-level,
  .right-find {
    margin-top: 5px;
    width: 90%;
    color: #e6a23c;
    line-height: 20px;
    font-size: 12px;
    word-break: break-word;

    &,
    i {
      font-weight: bold;
    }

    i {
      margin-right: 3px;
    }

    a {
      text-decoration: underline;
    }
  }
</style>
